import { capitalize } from 'es-toolkit';

import type { Member } from '@/entities/member/member-types';
import { CharacterAvatar } from '@/entities/user/components/character-avatar';
import { USER_ROLE } from '@/entities/user/user-constants';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/components/shadcn/select';
import { TableCell, TableRow } from '@/shared/components/shadcn/table';

interface MemberRowProps {
  member: Member;
  onPermissionChange: (member: Member) => void;
  gridTemplateColumns?: string;
  editable?: boolean;
}

const PERMISSIONS: USER_ROLE[] = [USER_ROLE.VIEWER, USER_ROLE.MANAGER];

export function MemberRow({
  member,
  onPermissionChange,
  gridTemplateColumns,
  editable,
}: MemberRowProps) {
  return (
    <TableRow gridTemplateColumns={gridTemplateColumns}>
      <TableCell className="!px-4 !py-2">
        <div className="flex items-center gap-2">
          <CharacterAvatar name={member.first_name} className="size-8" />
          <div className="flex flex-col">
            <span className="text-[14px] leading-[20px] font-medium text-zinc-900">
              {member.first_name} {member.last_name}
            </span>
            <span className="text-[14px] leading-[20px] text-zinc-500">{member.email}</span>
          </div>
        </div>
      </TableCell>
      <TableCell className="!px-4 !py-2">
        {member.privilege === USER_ROLE.OWNER ? (
          <span className="text-[14px] leading-[20px] text-zinc-500">Owner</span>
        ) : (
          <Select
            value={member.privilege}
            onValueChange={(value) =>
              onPermissionChange({ ...member, privilege: value as USER_ROLE })
            }
            disabled={!editable}
          >
            <SelectTrigger className="w-30">
              <SelectValue placeholder="Select a role" />
            </SelectTrigger>
            <SelectContent>
              {PERMISSIONS.map((p) => (
                <SelectItem key={p} value={p}>
                  {capitalize(p)}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        )}
      </TableCell>
    </TableRow>
  );
}
